import { render, staticRenderFns } from "./schemeLink.vue?vue&type=template&id=47440be3&scoped=true&"
import script from "./schemeLink.vue?vue&type=script&lang=js&"
export * from "./schemeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47440be3",
  null
  
)

export default component.exports